import React from 'react'
import {
  FormControl, InputLabel, Select, MenuItem, Grid, TextField, Box, Button,
  Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link,
  Accordion, AccordionSummary, AccordionDetails, IconButton, Input, Paper
} from '@mui/material';
import { Chip } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axiosInstance from '../lib/axios';
import Flag from '../Components/Ragistration/Booking/Flag';
import moment from 'moment';
import BokingCModal from '../Components/Ragistration/BConfirmation/BokingCModal';
import AccountGModal from '../Components/Ragistration/BConfirmation/AccountGModal';
import { useReactToPrint } from 'react-to-print';
import BReport from '../atoms/ReportFolder/BReport';
import axiosInstanceForPG from '../lib/axiosFormPG';
import CircularProgress from '@mui/material/CircularProgress';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ConfirmationDialog from './ReusableDailog';
import EmailIcon from '@mui/icons-material/Email';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../redux/propertySlice';
import CancelIcon from '@mui/icons-material/Cancel';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PrintIcon from '@mui/icons-material/Print';
import logo from '../../src/assets/Images/Clanbridge-logo.png2.png'
import { selectGatewayType } from '../redux/propertySlice';

const columns = [
  { id: 'BookId', label: 'BookId', minWidth: 50 },
  { id: 'BookNo', label: 'Booking No', minWidth: 120 },
  { id: 'BookDt', label: 'Book Date', minWidth: 130 },
  { id: 'BookSt', label: 'Status', minWidth: 130 },
  { id: 'ResidentName', label: 'Resident', minWidth: 130 },
  { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
  { id: 'Duration', label: 'Duration', minWidth: 100 },
  { id: 'CheckinDt', label: 'CheckIn', minWidth: 100 },
  { id: 'CheckoutDt', label: 'CheckOut', minWidth: 100 },
];


function Checkout(bookSt, onConfirm, bookId, onAccDetails, onAccGenerate) {
  const { register, watch, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [OpenLoader, setOpenLoader] = useState(false);
  const [TransactionData, setTransactionData] = useState([]);
  const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
  const [AccGenerate, setAccGenerate] = useState(false);
  const [BookId, setBookId] = useState(-1);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [searchTerms, setSearchTerms] = useState({});
  const [activeView, setActiveView] = useState('advice');
  const [Mode, setMode] = useState('add');
  const [loadingPaymentLinks, setLoadingPaymentLinks] = useState({});
  const location = useLocation();
  const contentRef = useRef(null);
  const [hasUnpaidRent, setHasUnpaidRent] = useState(false);
  const [switchState, setSwitchState] = useState(false);
  const [emailResponse, setEmailResponse] = useState(null);
  const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
  const [isDepositPaid, setIsDepositPaid] = useState(false);
  const [openCheckoutConfirm, setOpenCheckoutConfirm] = useState(false);
  const [openCheckinConfirm, setOpenCheckinConfirm] = useState(false);
  const handlePrint = useReactToPrint({ contentRef });
  const globalProperty = useSelector(selectGlobalProperty);
  const [showPayAdvice, setShowPayAdvice] = useState(false);
  const baseUrl = window.location.origin;
  const [payAdvice, setPayAdvice] = useState([]);
  const [isCheckoutProcessing, setIsCheckoutProcessing] = useState(false);
  const [selectedCheckoutDate, setSelectedCheckoutDate] = useState(new Date().toLocaleDateString('en-GB'));
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [oldBedId, setOldBedId] = useState('');
  const [residentid, setResidentId] = useState(null);
  const [propId, setPropId] = useState(null);
  const [selectedData, setSelectedDate] = useState(new Date().toLocaleDateString('en-GB'));
  const [minCheckInDate, setMinCheckInDate] = useState(null);
  const gatewayType = useSelector(selectGatewayType);
  
  const handlePrintNodues = async () => {
    if (BookId === -1) {
      toast.info("No booking selected");
      return;
    }

    try {
      const doc = new jsPDF();

      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const margin = 20;
      const contentWidth = pageWidth - (2 * margin);

      let yPos = 20;

      try {
        const logoImg = new Image();
        logoImg.src = logo;

        await new Promise((resolve, reject) => {
          logoImg.onload = () => {
            try {
              const canvas = document.createElement('canvas');
              canvas.width = logoImg.width;
              canvas.height = logoImg.height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(logoImg, 0, 0);

              const logoDataUrl = canvas.toDataURL('image/png');

              const logoWidth = 40;
              const logoHeight = (logoImg.height * logoWidth) / logoImg.width;
              doc.addImage(
                logoDataUrl,
                'PNG',
                margin,
                yPos,
                logoWidth,
                logoHeight
              );

              resolve();
            } catch (error) {
              reject(error);
            }
          };
          logoImg.onerror = reject;
        });
      } catch (logoError) {
        console.warn("Could not load logo, proceeding without it", logoError);
      }

      doc.setTextColor(99, 91, 255);
      doc.setFontSize(20);
      doc.text('Clanbridge Living Pvt Ltd', pageWidth / 2, yPos + 10, { align: 'center' });

      yPos += 25;
      doc.setFontSize(18);
      doc.setTextColor(0);
      doc.text('NO DUES CERTIFICATE', pageWidth / 2, yPos, { align: 'center' });

      yPos += 10;
      doc.setFontSize(12);
      doc.text(`Certificate No: NDC-${watch('BookNo')}-${moment().format('YYYYMMDD')}`, pageWidth / 2, yPos, { align: 'center' });

      yPos += 10;
      doc.text(`Date: ${moment().format('DD MMMM YYYY')}`, pageWidth / 2, yPos, { align: 'center' });

      yPos += 10;
      doc.setLineWidth(0.5);
      doc.line(margin, yPos, pageWidth - margin, yPos);

      yPos += 15;
      doc.setFontSize(12);

      const introText = `This is to certify that Mr./Ms. ${watch('ResidentName')}, bearing Mobile No. ${watch('MobileNo')}, was a resident at ${watch('PropName')} from ${formatDate(watch('CheckinDt'))} to ${formatDate(watch('CheckedOutDt'))}.`;
      const introLines = doc.splitTextToSize(introText, contentWidth);
      doc.text(introLines, margin, yPos);
      yPos += introLines.length * 7;

      yPos += 10;
      const paraText = `The resident has vacated the premises and after thorough verification, it is confirmed that all dues including rent, maintenance charges, utility bills, and other outstanding amounts have been cleared in full.`;
      const paraLines = doc.splitTextToSize(paraText, contentWidth);
      doc.text(paraLines, margin, yPos);
      yPos += paraLines.length * 7;

      yPos += 10;
      const paraText2 = `There are no pending dues or claims against the resident from Clanbridge Living Pvt Ltd.`;
      const paraLines2 = doc.splitTextToSize(paraText2, contentWidth);
      doc.text(paraLines2, margin, yPos);
      yPos += paraLines2.length * 7;

      yPos += 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Resident Details', margin, yPos);

      yPos += 10;
      doc.autoTable({
        startY: yPos,
        body: [
          ['Resident Name', watch('ResidentName') || ''],
          ['Mobile Number', watch('MobileNo') || ''],
          ['Email ID', watch('Email') || ''],
          ['Booking Number', watch('BookNo') || ''],
          ['Property', watch('PropName') || ''],
          ['Room/Bed', `${watch('WingName') || ''} - ${watch('FloorName') || ''} - ${watch('RoombedName') || ''}`],
          ['Room Type', watch('RoomTypeName') || ''],
          ['Check-in Date', formatDate(watch('CheckinDt'))],
          ['Check-out Date', formatDate(watch('CheckedOutDt'))],
          ['Duration', `${watch('Duration') || ''} months`],
          ['Plan', watch('PlanName') || '']
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        columnStyles: {
          0: { cellWidth: 50, fontStyle: 'bold' },
          1: { cellWidth: 80 }
        },
        margin: { left: margin, right: margin }
      });

      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Financial Summary', margin, yPos);

      yPos += 10;
      doc.autoTable({
        startY: yPos,
        body: [
          ['Total Contract Amount', ` ${watch('NetAmt') || '0'}`],
          ['Security Deposit', ` ${watch('DepositAmt') || '0'}`],
          ['Total Amount Paid', ` ${watch('AdvcRcble') || '0'}`],
          ['Outstanding Amount', ` 0`],
          ['Balance Status', 'FULLY SETTLED']
        ],
        theme: 'grid',
        styles: {
          fontSize: 11,
          cellPadding: 4,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        columnStyles: {
          0: { cellWidth: 70, fontStyle: 'bold' },
          1: { cellWidth: 60 }
        },
        margin: { left: margin, right: margin }
      });
      if (payAdvice.length > 0) {
        yPos = doc.lastAutoTable.finalY + 15;
        doc.setFontSize(16);
        doc.setTextColor(99, 91, 255);
        doc.text('Payment Status', margin, yPos);

        const paymentSummary = payAdvice.map(item => [
          item.PytAdvNo,
          moment(item.PytAdvDt).format('DD-MM-YYYY'),
          item.PytAdvFor === "D" ? "Deposit" :
            item.PytAdvFor === "R" ? "Rent" :
              item.PytAdvFor === "O" ? "Other" : "TopUp",
          ` ${item.Amount}`,
          item.PaymentSt || 'Paid'
        ]);

        yPos += 10;
        doc.autoTable({
          startY: yPos,
          head: [['Advice No', 'Date', 'Type', 'Amount', 'Status']],
          body: paymentSummary,
          theme: 'grid',
          styles: {
            fontSize: 9,
            cellPadding: 2,
            lineColor: [229, 231, 235],
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: [99, 91, 255],
            textColor: 255,
            fontStyle: 'bold'
          },
          margin: { left: margin, right: margin }
        });
      }

      yPos = doc.lastAutoTable.finalY + 20;
      doc.setFontSize(12);
      doc.setTextColor(0);

      const declaration = `This certificate is issued based on our records as on ${moment().format('DD MMMM YYYY')}. The resident has returned all keys and access cards, and the room has been inspected and found in good condition.`;
      const declarationLines = doc.splitTextToSize(declaration, contentWidth);
      doc.text(declarationLines, margin, yPos);
      yPos += declarationLines.length * 7;
      yPos += 20;
      doc.text('For and on behalf of', margin + 100, yPos);

      yPos += 5;
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.text('Clanbridge Living Pvt Ltd', margin + 100, yPos, { align: 'center' });

      yPos += 20;
      doc.setFont(undefined, 'normal');
      doc.setFontSize(10);
      doc.line(margin + 80, yPos, margin + 120, yPos);
      doc.text('Authorized Signatory', margin + 100, yPos + 5, { align: 'center' });

      yPos += 15;
      doc.setDrawColor(255, 0, 0);
      doc.setLineWidth(0.5);
      doc.rect(margin + 85, yPos - 10, 30, 15);
      doc.setFontSize(8);
      doc.setTextColor(255, 0, 0);
      doc.text('PAID', margin + 100, yPos - 5, { align: 'center' });
      doc.text('& CLEARED', margin + 100, yPos, { align: 'center' });

      doc.setFontSize(8);
      doc.setTextColor(128, 128, 128);
      const footerY = pageHeight - 10;
      doc.text('This is a computer-generated certificate. No physical signature required.', pageWidth / 2, footerY, { align: 'center' });

      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const printWindow = window.open(pdfUrl);

      if (printWindow) {
        printWindow.onload = function () {
          printWindow.focus();
          setTimeout(() => {
            try {
              printWindow.print();
            } catch (e) {
              console.warn("Print dialog blocked or failed", e);
              toast.info(
                <div>
                  Print dialog blocked.
                  <a href={pdfUrl} download={`NoDuesCertificate_${watch('BookNo')}_${moment().format('YYYYMMDD')}.pdf`}
                    style={{ color: '#635bff', marginLeft: '5px' }}>
                    Click here to download
                  </a>
                </div>
              );
            }
          }, 500);
        };
      }
    } catch (error) {
      toast.error('Failed to generate No Dues Certificate');
    }
  };

  useEffect(() => {
    if (BookId !== -1 && !isCheckoutProcessing) {
      fetchPayAdvice(BookId);
    }
  }, [BookId, isCheckoutProcessing]);

  useEffect(() => {
    // let MobileNo = location.state?.MobileNo;
    let BookId = location?.state?.BookId
    if (BookId) {
      // handleMobileChange(MobileNo, "B");
      fetchTransactionData(BookId);
    } else {
      setMode("add");
    }
    const fetchApi = async () => {
      setValue("CountryIcon", Flag);
      setValue("BookDt", "");
      setValue("BookDtFrom", "");
      setValue("BookUpToDt", "");
      // await fetchDataOfBooking();
    };
    fetchApi();
  }, [location.state?.BookId]);

  const fetchTransactionData = async (bookId) => {
    if (!bookId) return;

    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/RetriveTrnBooking`, {
        BookId: bookId,
        Flag: "R",
        CreatedBy: UserId
      }
      );

      if (response.data.Status === 0) {
        setIsDataLoaded(true);
        const bookingData = response.data.Data[0];
        const {
          BookSt, PropId, ResidentId, RoomBedId, CheckedOutDt, MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, CheckoutDt,
          TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, CheckinDt, Email, PlanName, MonthlyAmt, BookStatus
        } = bookingData;
        setAccountData(bookingData);
        setOldBedId(RoomBedId);
        setResidentId(ResidentId);
        setPropId(PropId);
        setBookId(bookId);
        setValue("MobileNo", MobileNo);
        setValue("ResidentName", ResidentName);
        setValue("BookNo", BookNo);
        setValue("BookDt", BookDt);
        setValue("Duration", Duration);
        setValue("BookDtFrom", BookDtFrom);
        setValue("BookUpToDt", BookUpToDt);
        setValue("CheckoutDt", CheckoutDt);
        setValue("TopupAmt", TopupAmt);
        setValue("AdvcRcble", AdvcRcble);
        setValue("DiscAmt", DiscAmt);
        setValue("TotalRent", TotalRent);
        setValue("NetAmt", NetAmt);
        setValue("BedRent", BedRent);
        setValue("FreeMonth", FreeMonth);
        setValue("PropName", PropName);
        setValue("Email", Email);
        setValue("PlanName", PlanName);
        setValue("MonthlyAmt", MonthlyAmt);
        setValue("CheckinDt", CheckinDt)
        setValue('CheckedOutDt', CheckedOutDt)
        if (BookSt === "C") {
          setSelectedDate(CheckinDt);
        } else {
          const currentDate = new Date().toISOString()?.split("T")[0];
          const bookFromDateObj = new Date(BookDtFrom);
          const currentDateObj = new Date(currentDate);
          bookFromDateObj.setHours(0, 0, 0, 0);
          currentDateObj.setHours(0, 0, 0, 0);
          setSelectedDate(currentDateObj >= bookFromDateObj ? currentDate : BookDtFrom);
        }

        setMinCheckInDate(BookDtFrom);
        setAccGenerate(BookSt === "B");
        setTransactionData(response.data.Data);
        await fetchPayAdvice(bookId);
        await fetchRoomBedData(RoomBedId, BookDtFrom, BookUpToDt, PropId);
        await fetchServicesData(bookingData.TransPlanId, bookingData.MessPlanId);
      } else {
        setIsDataLoaded(false);
        toast.info("Booking Not Found");
        resetFuncM();
      }
    } catch (error) {
      toast.error("Failed to load booking data");
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPayAdvice = async (BookId) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": moment().format("YYYY-MM-DD"),
        "Flag": "GenPytAdv",
        "BookId": BookId
      });

      if (response.data.Status === 0) {
        setPayAdvice(response.data.Data);
        setShowPayAdvice(true);

        const unpaidRentExists = response.data.Data.some(
          item => item.PytAdvFor === "R" && item.IsDepPaid !== "Y"
        );
        const firstInstallmentPaid = response.data.Data.some(
          item => item.PytAdvFor === "R" &&
            item.Remark?.includes("Installment 1") &&
            item.IsDepPaid === "Y"
        );

        setHasUnpaidRent(unpaidRentExists && !firstInstallmentPaid);
      }
    } catch (error) {
      toast.error('Error fetching payment advice:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    if (TransactionData.length > 0) {
      const { MobileNo, ResidentName, CheckinDt, BookNo, CheckoutDt, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PropId } = TransactionData[0];
      let obj = { ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, CheckinDt, PropId }

      setValue("MonthlyAmt", Math.round(NetAmt / Duration));
      setObjValue(obj);
      setValue("Email", Email);
      setValue("PropId", PropId);
      setValue("CheckinDt", CheckinDt)
      setBookId(BookId)
      const fetchDataAndSet = async () => {
        await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
        await fetchPlanData(TransactionData[0].RoomPlanId);
        await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);
      }
      fetchDataAndSet();
      setNetAmount();
    }
  }, [TransactionData, globalProperty]);

  useEffect(() => {
    const today = dayjs();
    const formattedToday = today.format('DD/MM/YYYY');
    setValue('CheckoutDt', formattedToday);
    setSelectedCheckoutDate(formattedToday);
  }, []);

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);

  const fetchDataOfBooking = async () => {
    try {
      const response = await axiosInstance.post(
        `TrnBooking/GetTrnBookingDashBoard`,
        {
          PageNumber: 1,
          PageSize: 1,
          SearchText: '',
          Flag: 'PendChkOut',
          MobileNo: '',
          BookNo: '',
          PropId: globalProperty,
        }
      );

      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map(checkout => ({
          ...checkout,
          BookSt: checkout.BookSt === "O" ? "CheckedIn" : checkout.BookSt === "X" ? "Cancel" : ""
        }));
        setRows(formattedData);
      } else {
        toast.error(response.data.Message);
        setRows([]);
      }
    } catch (error) {
      toast.error('Error fetching Booking data:', error);
    }
  };

  const handleMobileChange = async (e, Separator) => {
    let val = "";
    if (Separator === "A") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    if (val.length >= 10) {
      try {
        const response = await axiosInstance.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": '',
            "Flag": '',
            "MobileNo": val,
            "BookNo": '',
            "PropId": 1,
          }
        );

        if (response.data.Status === 0) {
          setIsDataLoaded(true);
          const { BookSt, IsDepPaid } = response.data.Data[0];
          const data = response.data.Data[0]
          setAccountData(data);
          setIsDepositPaid(IsDepPaid === "Y");
          setIsBookingConfirmed(BookSt === "O");
          setSwitchState(BookSt === "O");
          if (BookSt === "B") {
            setAccGenerate(false);
          } else {
            setAccGenerate(true);
          }
          setTransactionData(response.data.Data);
          await fetchPayAdvice(response.data.Data[0].BookId);
        } else {
          setIsDataLoaded(false);
          toast.info("Booking Doesn't Exist On This Number");
          resetFuncM();
          setValue("BookNo", "");
          setBookId(-1);
        }
      } catch (error) {
        toast.error('Error fetching data:', error);
      }
    } else if (val.length === 9) {
      resetFuncM();
      setValue("BookNo", "");
      setBookId(-1);
    }
    Separator === "B" && handleClose();
  };

  const handleBookNoChange = async (e, Separator) => {
    let val = "";
    if (Separator === "A") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    if (val.length >= 8) {
      try {
        const response = await axiosInstance.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": '',
            "Flag": '',
            "MobileNo": '',
            "BookNo": val,
            "PropId": 1,
          }
        );

        if (response.data.Status === 0) {
          setIsDataLoaded(true);
          const { BookSt, IsDepPaid } = response.data.Data[0];
          setIsDepositPaid(IsDepPaid === "Y");
          setIsBookingConfirmed(BookSt === "O");
          setSwitchState(BookSt === "O");

          if (BookSt === "B") {
            setAccGenerate(true);

          } else {
            setAccGenerate(false);
          }
          setTransactionData(response.data.Data);
          await fetchPayAdvice(response.data.Data[0].BookId);
        } else {
          toast.info("Booking Doesn't Exist On This Number");
          resetFuncM();
          setValue("MobileNo", "");
          setBookId(-1);
        }
      } catch (error) {
        toast.error('Error fetching Booking data:', error);
      }
    } else if (val.length === 7) {
      setIsDataLoaded(false);
      resetFuncM();
      setValue("MobileNo", "");
    }
    Separator === "B" && handleClose();
  }

  const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
    try {
      const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
        BookFromDt: date1,
        BookToDt: date2,
        PropId: PropId,
        Flag: "",
        RoomBedId: RoomBedId
      });

      if (response.data.Status === 0) {
        handleRowDoubleClick(response.data.Data[0]);
      }
    } catch (error) {
      toast.error('Error fetching company data:', error);
    }
  };

  const fetchPlanData = async (PlanId) => {
    try {
      const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
        "RoomPlanID": PlanId,
        "Flag": "R"
      });

      if (response.data.Status === 0) {
        setPlanData(response.data.Data);
      }
    } catch (error) {
      toast.error('Error fetching company data:', error);
    }
  };

  const handleRowDoubleClick = async (row) => {
    const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, } = row;
    const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, };
    setObjValue(obj);
  };

  const setPlanData = (PlanArr) => {
    const { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt } = PlanArr[0];
    const obj = { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt };
    setObjValue(obj);
  }


  const setObjValue = (obj) => {
    for (let key in obj) {
      setValue(key, obj[key]);
    }
  }

  const handleClose = () => {
    setOpenHistoryTableDialog(false);
    setPage(0);
    setTimeout(() => {
      setSearchTerms({});
    }, [500]);

  };

  const handleClickCheckAva = async () => {
    await fetchDataOfBooking();
    setOpenHistoryTableDialog(true);
  };

  const setNetAmount = () => {
    setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
  };

  const fetchServicesData = async (TransPlanId, MessPlanId) => {
    const Flag = "";
    try {
      const response = await axiosInstance.post(
        `MstTransPlan/getMstTransPlandrp`,
        { Flag, UserId },
      );

      if (response.data.Status === 0) {
        // setTransPlanDrp(response.data.Data);
        let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
        if (obj) {
          setValue("TAmount", obj.Amount);
        } else {
          setValue("TAmount", 0);
        }
        setNetAmount()
      } else {
        toast.error('Error fetching Trans data');
      }
    } catch (error) {
      toast.error('Error fetching property data');
    }
    try {
      const response = await axiosInstance.post(
        `MstMessPlan/getMstMessPlandrp`,
        { Flag, UserId },
      );

      if (response.data.Status === 0) {

        let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
        if (obj) {
          setValue("MAmount", obj.Amount);
        } else {
          setValue("MAmount", 0);
        }
        setNetAmount();
      } else {
      }
    } catch (error) {
      toast.error('Error fetching Plan data');
    }
  }
  const resetFuncM = () => {
    const obj = {
      "ResidentName": "",
      "BookDt": "",
      "Duration": "",
      "BookDtFrom": "",
      "BookUpToDt": "",
      "WingName": "",
      "FloorName": "",
      "RoomTypeName": "",
      "RoombedName": "",
      "RoomBedTypeName": "",
      "BedRent": "",
      "PlanName": "",
      "PlanTenur": "",
      "FreeMonth": "0",
      "LastAdjMonths": "0",
      "IncRentPerc": "",
      "DepositAmt": "",
      "TopupAmt": "",
      "Tamt": "",
      "MAmount": "",
      "TAmount": "",
      "TotalRent": "",
      "DiscAmt": "",
      "NetAmt": "",
      "MonthlyAmt": "",
      "PropName": "",
    }
    for (let key in obj) {
      setValue(key, "")
    }
    setValue("CountryIcon", Flag);

  };

  const handleCheckoutClick = () => {
    if (BookId === -1) {
      toast.info("Nothing Any Transaction Is Visible");
      return;
    }
    if (!isBookingConfirmed) {
      toast.info("Booking is not confirmed yet");
      return;
    }
    const allPaid = payAdvice.every(item => item.PaymentSt === "Paid");

    if (!allPaid) {
      toast.info("Cannot checkout - all installments and deposits must be paid first");
      return;
    }
    const actualCheckout = dayjs(watch('CheckoutDt'), 'DD/MM/YYYY');
    const plannedCheckout = dayjs(watch('BookUpToDt'), 'DD/MM/YYYY');

    if (actualCheckout.isBefore(plannedCheckout, 'day')) {
      toast.warning('This is an early checkout!');
    }
    setOpenCheckoutConfirm(true);
  };

  const handleCheckoutConfirm = async () => {
    setOpenLoader(true);
    setOpenCheckoutConfirm(false);
    setIsCheckoutProcessing(true);

    try {
      const checkoutDate = watch('CheckedOutDt');
      let formattedDate;

      if (checkoutDate && checkoutDate.trim() !== '') {
        formattedDate = dayjs(checkoutDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
      } else {
        formattedDate = dayjs().format('YYYY-MM-DDTHH:mm:ss');
      }
      // const formattedDate = dayjs(checkoutDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
      const response = await axiosInstance.post(
        `TrnBooking/TrnBookingConfirmation`,
        {
          "BookId": BookId,
          "CreatedBy": UserId,
          "Flag": "L",
          // "CreatedDate": TransactionData[0].CheckoutDt
          "CreatedDate": formattedDate,
        },
      );

      if (response.data.Status === 0) {
        toast.success("CheckOut Successfully");
        setTransactionData(prevData =>
          prevData.map(item => ({
            ...item,
            BookSt: "L"
          }))
        );
        setSwitchState(false);
        setIsBookingConfirmed(false);
      } else {
        toast.error(response.data.Message || "Operation failed");
      }
    } catch (error) {
      toast.error('Error fetching CheckIn data');
    } finally {
      setOpenLoader(false);
      setIsCheckoutProcessing(false);
    }
  };

  const generatePDFContent = () => {
    try {
      const doc = new jsPDF();
      let yPos = 20;
      const pageWidth = doc.internal.pageSize.width;
      const margin = 20;
      const contentWidth = pageWidth - (2 * margin);
      doc.setTextColor(99, 91, 255); // #635bff
      doc.setFontSize(20);
      doc.text('Clanbridge Living Pvt Ltd', pageWidth / 2, yPos, { align: 'center' });

      yPos += 10;
      doc.setFontSize(18);
      doc.setTextColor(0);
      doc.text('Booking Confirmation', pageWidth / 2, yPos, { align: 'center' });
      yPos += 15;
      doc.autoTable({
        startY: yPos,
        head: [
          [{ content: 'Booking Summary', colSpan: 4, styles: { halign: 'center', fillColor: [99, 91, 255], textColor: 255 } }]
        ],
        body: [
          [
            { content: 'Booking No', styles: { fontStyle: 'bold' } },
            watch('BookNo') || '',
            { content: 'Book Date', styles: { fontStyle: 'bold' } },
            moment(watch('BookDt')).format('DD-MM-YYYY')
          ],
          [
            { content: 'Mobile', styles: { fontStyle: 'bold' } },
            watch('MobileNo') || '',
            { content: 'Email', styles: { fontStyle: 'bold' } },
            watch('Email') || ''
          ],
          [
            { content: 'From Date', styles: { fontStyle: 'bold' } },
            moment(watch('BookDtFrom')).format('DD-MM-YYYY'),
            { content: 'To Date', styles: { fontStyle: 'bold' } },
            moment(watch('BookUpToDt')).format('DD-MM-YYYY')
          ],
          [
            { content: 'Duration', styles: { fontStyle: 'bold' } },
            watch('Duration') || '',
            { content: 'Property Name', styles: { fontStyle: 'bold' } },
            watch('PropName') || ''
          ],
          [
            { content: 'Resident Name', styles: { fontStyle: 'bold' } },
            { content: watch('ResidentName') || '', colSpan: 3 }
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Room Details', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        body: [
          [
            { content: 'Wing', styles: { fontStyle: 'bold' } },
            watch('WingName') || '',
            { content: 'Floor', styles: { fontStyle: 'bold' } },
            watch('FloorName') || '',
            { content: 'Room Type', styles: { fontStyle: 'bold' } },
            watch('RoomTypeName') || ''
          ],
          [
            { content: 'Bed No', styles: { fontStyle: 'bold' } },
            watch('RoombedName') || '',
            { content: 'Bed Type', styles: { fontStyle: 'bold' } },
            watch('RoomBedTypeName') || '',
            { content: 'Standard Rent', styles: { fontStyle: 'bold' } },
            watch('BedRent') || ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });


      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Plan Details', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        body: [
          [
            { content: 'Plan', styles: { fontStyle: 'bold' } },
            watch('PlanName') || '',
            { content: 'Duration', styles: { fontStyle: 'bold' } },
            watch('Duration') || ''
          ],
          [
            { content: 'Free Months', styles: { fontStyle: 'bold' } },
            watch('FreeMonth') || '0',
            { content: 'Min Adv Month', styles: { fontStyle: 'bold' } },
            watch('LastAdjMonths') || '0'
          ],
          [
            { content: 'Increment %', styles: { fontStyle: 'bold' } },
            watch('IncRentPerc') || '0',
            { content: 'Deposit', styles: { fontStyle: 'bold' } },
            watch('DepositAmt') || ''
          ],
          [
            { content: 'Total Rent', styles: { fontStyle: 'bold' } },
            watch('TotalRent') || '',
            { content: 'Discount', styles: { fontStyle: 'bold' } },
            watch('DiscAmt') || ''
          ],
          [
            { content: 'Net Amount', styles: { fontStyle: 'bold' } },
            watch('NetAmt') || '',
            { content: 'Monthly Amount', styles: { fontStyle: 'bold' } },
            watch('MonthlyAmt') || ''
          ],
          [
            { content: 'Net Payable', styles: { fontStyle: 'bold' } },
            watch('AdvcRcble') || '',
            { content: '', styles: { fontStyle: 'bold' } },
            ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Other Services', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        body: [
          [
            { content: 'Topup Amount', styles: { fontStyle: 'bold' } },
            watch('TopupAmt') || '',
            { content: 'Transport Service', styles: { fontStyle: 'bold' } },
            watch('TAmount') || ''
          ],
          [
            { content: 'Mess Service', styles: { fontStyle: 'bold' } },
            watch('MAmount') || '',
            { content: 'Total Amount', styles: { fontStyle: 'bold' } },
            watch('TotalAmt') || ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });

      // Footer
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.setTextColor(0);
      doc.text('Thank you for choosing Clanbridge Living Pvt Ltd', margin, yPos);
      doc.text('For any queries, please contact: support@clanbridgeliving.in', margin, yPos + 5);

      return doc;
    } catch (error) {
      return null;
    }
  };

  const handleEmailSentLink = async () => {
    setOpenLoader(true);
    const userEmail = watch("Email");
    const propId = parseInt(watch("PropId"));
    const userId = parseInt(UserId);

    if (!userEmail) {
      toast.error("Email address not available");
      setOpenLoader(false);
      return;
    }

    try {
      // Generate PDF
      const doc = generatePDFContent();
      if (!doc) {
        toast.error("Failed to generate PDF document");
        setOpenLoader(false);
        return;
      }
      const pdfData = doc.output();
      const pdfBase64 = btoa(pdfData);
      const pdfDataUri = `data:application/pdf;base64,${pdfBase64}`;
      const startDate = moment(watch('BookDtFrom')).format('DD MMM YYYY');
      const endDate = moment(watch('BookUpToDt')).format('DD MMM YYYY');

      const Subject = `Resident Booking Confirmation - ${watch("BookNo")} - ${watch("ResidentName")}`;
      const Body = `
      Dear ${watch("ResidentName")},<br><br>
      
      I hope you are doing well.<br><br>
      
      We are pleased to confirm your booking for ${watch("PropName")} has been successfully processed. 
      Please find attached the relevant booking details for your reference.<br><br>
      
      Here are the key details of your booking:<br>
      • <strong>Booking No</strong>: ${watch("BookNo")}<br>
      • <strong>Booking Dates</strong>: ${startDate} to ${endDate}<br>
      • <strong>Property</strong>: ${watch("PropName")}<br>
     
      For your convenience, we have attached the booking confirmation document for your records. 
      If you have any questions or need further assistance, please feel free to reach out to us.<br><br>
      
      Thank you for choosing Clanbridge Living Pvt Ltd. We look forward to welcoming you.<br><br>
      
      Best regards,<br>
      Clanbridge Living Pvt Ltd<br>
      Email: support@clanbridgeliving.in<br>
      Contact: +91 XXX XXX XXXX
    `;

      const emailRequest = {
        ToEmail: userEmail ? [userEmail] : [],
        Subject,
        Body,
        ImgFolderNm: watch("BookNo"),
        DocAttachments: [{
          FileName: `Booking_${watch("BookNo")}.pdf`,
          FileContent: pdfDataUri
        }],
        PropId: propId,
      };

      const response = await axiosInstanceForPG.post(
        `EmailRequest/SendEmail`,
        emailRequest
      );

      if (response.data.Status === 0) {
        toast.success("Email sent successfully");
      } else {
        toast.error(response.data.Message || "Failed to send email");
      }
    } catch (error) {
      toast.error(`Failed to send email: ${error.message}`);
    } finally {
      setOpenLoader(false);
    }
  };

  const handleClickCancel = () => {
    navigate("/checkouttab");
  }

  const handleCheckInClick = () => {
    if (BookId === -1) {
      toast.info("Nothing Any Transaction Is Visible");
      return;
    }

    setOpenCheckinConfirm(true);
  };

  const handleCheckinConfirm = async () => {
    setOpenLoader(true);
    setOpenCheckinConfirm(false);

    try {
      const response = await axiosInstance.post(
        `TrnBooking/TrnBookingConfirmation`,
        {
          "BookId": BookId,
          "CreatedBy": UserId,
          "Flag": "O"
        },
      );

      if (response.data.Status === 0) {
        toast.success("Checkout Cancel Successfully");
        setTransactionData(prevData =>
          prevData.map(item => ({
            ...item,
            BookSt: "O"
          }))
        );
        setSwitchState(true);
        setIsBookingConfirmed(true);

        await fetchPayAdvice(BookId);

      } else {
        toast.error(response.data.Message || "Operation failed");
      }
    } catch (error) {
      toast.error('Error fetching CheckIn data');
    } finally {
      setOpenLoader(false);
    }
  };

  const formatDate = (date) => {
    if (!date || !moment(date).isValid()) return '';
    return moment(date).format('DD/MM/YYYY');
  };


const handleSendPaymentLink = async (item) => {
  console.log("Sending payment link for item:", item);
  try {
    setIsLoading(true);
    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: true }));
    const userId = parseInt(sessionStorage.getItem('UserId'));
    const baseUrl = window.location.origin;
    
    // const gatewayType = gatewayType || 'CashFree';
    
    let paymentResponse = null;

    if (gatewayType === 'CashFree') {
      const paymentDetails = {
        customer_details: {
          customer_email: item.Email,
          customer_name: item.ResidentName,
          customer_phone: item.MobileNo
        },
        link_amount: item.Amount || 0,
        link_auto_reminders: true,
        link_currency: "INR",
        link_expiry_time: "2026-06-09T15:04:05+05:30",
        link_id: "Testing9062026",
        PropId: item.PropId,
        link_meta: {
          notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
          return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
          upi_intent: false
        },
        link_minimum_partial_amount: parseFloat(item.Amount) || 0,
        link_notes: {
          key_1: "CashFreepay",
          key_2: "linkCashfree"
        },
        link_notify: {
          send_email: true,
          send_sms: true
        },
        link_partial_payments: true,
        link_purpose: item.Remark,
        ResidentId: item.ResidentId,
        Flag: "Active",
        Remark: "Testing",
        TrjType: "TrnPytAdv",
        TrjDocNo: item.PytAdvNo,
        TrjDocId: item.BookId,
        cf_payment_id: "",
        payment_status: "",
        PropId: item.PropId,
      };

      const response = await axiosInstanceForPG.post(
        `PaymentGatewayLog/CreateCashFreeLink`,
        paymentDetails,
      );

      if (response.data.Status == 0) {
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
        setIsLoading(false);
        return toast.success(response.data.Message);
      }
      if (response.data.Status == 1) {
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
        setIsLoading(false);
        return toast.error(response.data.Message);
      }

      paymentResponse = response.data;
      if (typeof paymentResponse === 'string') {
        paymentResponse = JSON.parse(paymentResponse);
      }

      if (!paymentResponse || !paymentResponse.link_url) {
        console.error("Invalid payment response:", paymentResponse);
        toast.error("Failed to create payment link");
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
        setIsLoading(false);
        return;
      }

    } else if (gatewayType === 'Instamojo') {
      const paymentDetails = {
        purpose: item.Remark || `Payment Advice ${item.PytAdvNo}`,
        amount: item.Amount || 0,
        buyer_name: item.ResidentName || '',
        email: item.Email || '',
        phone: item.MobileNo || '',
        redirect_url: `${baseUrl}/payment-success`,
        redirecturl: `${baseUrl}/payment-success/`,
        webhook_url: '',
        ResidentId: item.ResidentId,
        TrjDocId: item.PytAdvId || 0,
        TrjType: "TrnPytAdv",
        TrjDocNo: item.PytAdvNo || '',
        PropId: item.PropId || 0,
      };

      const response = await axiosInstanceForPG.post(
        `Payment/CreatePaymentOrder`,
        paymentDetails,
      );

      if (response.data.Status === 0) {
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
        setIsLoading(false);
        return toast.success(response.data.Message);
      }

      paymentResponse = JSON.parse(response.data);

      if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
        console.error("Invalid payment response:", paymentResponse);
        toast.error("Failed to create payment link");
        setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
        setIsLoading(false);
        return;
      }

    } else {
      toast.error(`Unsupported gateway type: ${gatewayType}`);
      setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
      setIsLoading(false);
      return;
    }

    const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
    const paymentUrl = gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
    const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

    let paymentLogPayload;
    if (gatewayType === 'CashFree') {
      paymentLogPayload = {
        id: paymentResponse.link_id,
        cf_link_id: paymentResponse.cf_link_id,
        phone: paymentResponse.customer_details.customer_phone,
        email: paymentResponse.customer_details.customer_email,
        buyer_name: paymentResponse.customer_details.customer_name || 'null',
        amount: paymentResponse.link_amount,
        purpose: paymentResponse.link_purpose,
        expires_at: null,
        status: paymentResponse.link_status,
        send_sms: paymentResponse.link_notify.send_sms,
        send_email: paymentResponse.link_notify.send_email,
        sms_status: 'null',
        email_status: 'null',
        shorturl: 'null',
        longurl: paymentResponse.link_url,
        redirect_url: paymentResponse.link_meta.return_url,
        webhook: 'null',
        allow_repeated_payments: true,
        created_at: paymentResponse.link_created_at,
        modified_at: paymentResponse.link_created_at,
        ResidentId: item.ResidentId,
        link_qrcode: paymentResponse.link_qrcode,
        TrjDocNo: item.PytAdvNo,
        TrjDocId: item.PytAdvId,
        TrjType: "TrnPytAdv",
        Flag: "Active",
        Remark: "Payment Link for Payment Advice",
        Gatewaytype: "CashFree",
      };
    } else {
      paymentLogPayload = {
        id: paymentResponse.payment_request.id,
        phone: paymentResponse.payment_request.phone,
        email: paymentResponse.payment_request.email,
        buyer_name: paymentResponse.payment_request.buyer_name,
        amount: paymentResponse.payment_request.amount,
        purpose: paymentResponse.payment_request.purpose,
        expires_at: paymentResponse.payment_request.expires_at,
        status: paymentResponse.payment_request.status,
        send_sms: paymentResponse.payment_request.send_sms,
        send_email: paymentResponse.payment_request.send_email,
        sms_status: paymentResponse.payment_request.sms_status,
        email_status: paymentResponse.payment_request.email_status,
        shorturl: paymentResponse.payment_request.shorturl,
        longurl: paymentResponse.payment_request.longurl,
        redirect_url: paymentResponse.payment_request.redirect_url,
        webhook: paymentResponse.payment_request.webhook,
        allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
        created_at: paymentResponse.payment_request.created_at,
        modified_at: paymentResponse.payment_request.modified_at,
        ResidentId: item.ResidentId,
        TrjDocNo: item.PytAdvNo,
        TrjDocId: item.PytAdvId,
        TrjType: "TrnPytAdv",
        Flag: "Active",
        Remark: "Payment Link for Payment Advice",
        Gatewaytype: "Instamojo",
      };
    }

    await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

    const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${item.PytAdvNo}]`;
    const Body = `Hey <strong>${item.ResidentName}</strong>,<br><br>
          We would like to inform you that payment advice has been created for you tenancy at <strong>${item.PropName}</strong>.Please find attached your payment advice with this email <br><br>
          Following are the details : <br><br>
          Advice No: <strong>${item.PytAdvNo}</strong><br>
          Amount: <strong>${item.Amount}</strong><br>
          Date Of Issue: <strong>${formatDate(item.PytAdvDt)}</strong><br>
          Due Date: <strong>${formatDate(item.DueDt)}</strong><br>
          <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
          We hope you are having a pleasant stay with us. Do let us know if you need any assitance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
          Cheers,<br>
          Team Clanbridge`;

    const emailRequest = {
      ToEmail: item.Email ? [item.Email] : [],
      Subject,
      Body,
      Attachments: '',
      attachmentFilePaths: [],
      PropId: item.PropId,
      UserId: userId,
    };

    const emailResponse = await axiosInstanceForPG.post(
      `EmailRequest/SendEmail`,
      emailRequest,
    );

    if (emailResponse.data.Status === 0) {
      toast.success(`Payment Link Sent Successfully for ${item.PytAdvNo}`);
    } else {
      toast.info(emailResponse.data.Message);
    }

    fetchPayAdvice(activeView === 'advice' ? 'GenPytAdv' : 'BookingWise');

  } catch (error) {
    console.error('Error sending payment link:', error);
    toast.error("Failed to send payment link");
  } finally {
    setLoadingPaymentLinks(prev => ({ ...prev, [item.PytAdvId]: false }));
    setIsLoading(false);
  }
};

  return (
    <>
      <Box className="form-container">
        <ToastContainer />
        <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog} handleClose={handleClose} columns={columns} TextField={TextField} handleSearchChange={handleSearchChange} filteredRows={filteredRows} page={page} rowsPerPage={rowsPerPage} handleMobileChange={handleMobileChange} handleBookNoChange={handleBookNoChange} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
        <Grid container spacing={3} className="rasidant_grid" >
          <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center">
            <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', pb: 1 }}>
              <Typography variant="h5" align="center">
                Check-Out
              </Typography>
              <Tooltip title="Print Nodues">
                <IconButton
                  onClick={handlePrintNodues}
                  variant="contained"
                  size="small"
                  sx={{
                    backgroundColor: '#635bff',
                    color: 'white',
                    borderRadius: '7px',
                    padding: '3px 8px',
                    marginLeft: '10px',
                    '&:hover': {
                      backgroundColor: '#1565c0',
                    }
                  }}
                // disabled={BookId === -1 || !isBookingConfirmed}
                >
                  <PrintIcon />
                </IconButton>
              </Tooltip>
              {TransactionData && TransactionData.length > 0 && TransactionData[0].BookSt === "L" && (
                <Tooltip title="Cancel this checkout" arrow>
                  <Box sx={{ position: 'absolute', right: 0 }}>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundColor: "#e01c0dff",
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        height: 35,
                        borderRadius: '9px',
                        '&:hover': {
                          boxShadow: '0 5px 8px 2px rgba(255, 82, 82, .4)',
                          background: '#c52838ff'
                        },
                      }}
                      onClick={handleCheckInClick}
                    >
                      <CancelIcon sx={{ fontSize: '18px', mr: 1 }} />
                      Cancel
                    </Button>
                  </Box>
                </Tooltip>
              )}
            </Box>

            <Grid container md={12} spacing={0.5}>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" fullWidth>
                  <OutlinedInput
                    id="outlined-adornment-weight"
                    startAdornment={
                      <InputAdornment position="start">
                        <div
                          style={{
                            width: 25,
                            height: 15,
                            backgroundImage: `url(${watch("CountryIcon")})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            borderRadius: '4px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        />
                      </InputAdornment>
                    }
                    aria-describedby="outlined-weight-helper-text"
                    placeholder={`Enter Valid  Mobile Number`}
                    style={{ width: "100%", height: 40 }}

                    value={watch('MobileNo') || ''}
                    {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
                    inputProps={{
                      'aria-label': 'weight',
                      style: { height: 40 },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="PropName"
                  name="PropName"
                  label="Property Name"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('PropName') || ''}
                  {...register('PropName')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="ResidentName"
                  name="ResidentName"
                  label="First Name"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('ResidentName') || ''}
                  {...register('ResidentName')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={
                      <>
                        Actual CheckOut <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                    value={
                      watch('CheckedOutDt')
                        ? dayjs(watch('CheckedOutDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])
                        : dayjs()
                    }
                    onChange={(newValue) => {
                      if (newValue) {
                        const formattedDate = newValue.format('DD/MM/YYYY');
                        setValue('CheckedOutDt', formattedDate);
                        setSelectedCheckoutDate(formattedDate);
                      } else {
                        setValue('CheckedOutDt', '');
                        setSelectedCheckoutDate('');
                      }
                    }}
                    minDate={dayjs(watch('CheckinDt'), ['DD/MM/YYYY', 'YYYY-MM-DD'])}

                    format="DD/MM/YYYY"
                    slotProps={{
                      textField: {
                        variant: 'filled',
                        fullWidth: true,
                        className: 'custom-textfield',
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="BookNo"
                  name="BookNo"
                  label="Book No"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('BookNo') || ''}
                  {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="BookDt"
                  name="BookDt"
                  label="Book Date"
                  variant="filled"
                  // type="date"
                  fullWidth
                  className="custom-textfield"
                  value={formatDate(watch('BookDt'))}
                  {...register('BookDt')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="Duration"
                  name="Duration"
                  label="Duration"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={watch('Duration') || ''}
                  {...register('Duration')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="CheckinDt"
                  name="CheckinDt"
                  // type="date"
                  label="Checkin Date"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formatDate(watch('CheckinDt'))}
                  {...register('CheckinDt')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="BookUpToDt"
                  name="BookUpToDt"
                  label="Checkout Date"
                  // type="date"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formatDate(watch('BookUpToDt'))}
                  {...register('BookUpToDt')}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={12} md={2} sx={{ display: "flex", gap: 1, justifyContent: { xs: 'flex-end', md: 'flex-start' }, alignItems: 'center' }}>
                <Tooltip title='Get booking details data' arrow>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: "#635bff",
                      height: 35,
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      borderRadius: '9px'
                    }}
                    onClick={handleClickCheckAva}
                  >
                    Get Data
                  </Button>
                </Tooltip>
                <Tooltip title='Credit Note' arrow>
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      backgroundColor: "#635bff",
                      height: 35,
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      borderRadius: '9px'
                    }}
                    onClick={() => navigate("/cradit-notestable")}
                  >
                    Credit Note
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
            <hr></hr>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Typography variant="h6" gutterBottom >
                  Room Details
                </Typography>
              </Grid>
              {/* Work Info Column */}
              <Grid item xs={12} sm={10}>
                <Grid container spacing={1} >
                  <Grid item xs={12} md={4} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                    <TextField
                      id="WingName"
                      name="WingName"
                      label="Wing"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('WingName') || ''}
                      {...register('WingName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={4} sx={{ display: { xs: 'none', sm: 'flex', md: 'flex' } }}>
                    <TextField
                      id="FloorName"
                      name="FloorName"
                      label="Floor"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('FloorName') || ''}
                      {...register('FloorName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="RoomTypeName"
                      name="RoomTypeName"
                      label="Room Type"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('RoomTypeName') || ''}
                      {...register('RoomTypeName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="RoombedName"
                      name="RoombedName"
                      label="Bed No"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('RoombedName') || ''}
                      {...register('RoombedName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="RoomBedTypeName"
                      name="RoomBedTypeName"
                      label="Bed Type"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={watch('RoomBedTypeName') || ''}
                      {...register('RoomBedTypeName')}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="BedRent"
                      name="BedRent"
                      label="Standard Rent"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      {...register('BedRent')}
                      value={watch('BedRent') || ''}
                      InputProps={{
                        readOnly: true,
                      }}
                      disabled={true}
                    />
                  </Grid>
                </Grid>
                {/* </Paper> */}
              </Grid>
            </Grid>
            <hr></hr>
            <Grid container spacing={1} sx={{ mt: 1, display: { xs: 'none', sm: 'none' } }}>
              <Grid item xs={12} sm={2}>
                <Typography variant="h6" gutterBottom >
                  Outstanding Amount
                </Typography>
              </Grid>

              {/* Work Info Column */}
              <Grid item xs={12} sm={10} >
                <Grid container spacing={1}  >
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="TopupAmt"
                      name="TopupAmt"
                      label="Outstanding Amount"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      {...register('TopupAmt')}
                      value={watch('TopupAmt') || ''}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="TAmount"
                      name="TAmount"
                      label="Transport Service"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      {...register('TAmount')}
                      value={watch('TAmount') || ''}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      id="MAmount"
                      name="MAmount"
                      label="Mess Service"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      {...register('MAmount')}
                      value={watch('MAmount') || ''}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                </Grid>
                {/* </Paper> */}
              </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ display: { xs: 'none', sm: 'flex' } }}>
              {/* Work Info Column */}
              <Grid item xs={12} sm={10} >
                <Grid container spacing={1}   >
                  <Grid item xs={12} sm={12} md={6} display="flex" alignItems="center">
                    <Typography variant="h6" gutterBottom sx={{ mr: 1 }}>
                      Booking Status:
                    </Typography>

                    {/* <Typography variant="h6" gutterBottom sx={{ color: isDepositPaid ? "green" : "red" }}>
                          {isDepositPaid ? "Paid" : "Unpaid"}
                      </Typography> */}

                    {TransactionData && TransactionData.length > 0 ? (
                      <Typography
                        component="span"
                        style={{
                          color: TransactionData[0].BookSt === "C" ? "green" :
                            TransactionData[0].BookSt === "B" ? "blue" :
                              TransactionData[0].BookSt === "O" ? "orange" : "red",
                          fontWeight: "bold",
                          marginLeft: "8px"
                        }}
                      >
                        {TransactionData[0].BookSt === "C"
                          ? "Confirmed"
                          : TransactionData[0].BookSt === "B"
                            ? "Booked"
                            : TransactionData[0].BookSt === "O"
                              ? "CheckedIn"
                              : TransactionData[0].BookSt === "L"
                                ? "CheckOut"
                                : TransactionData[0].BookSt === "X"
                                  ? "Cancelled"
                                  : "Unknown"}
                      </Typography>
                    ) : (
                      <Typography variant="body1" sx={{ color: 'gray', fontWeight: 'bold' }}>
                        Not Found
                      </Typography>
                    )}
                  </Grid>

                  <Grid container spacing={2} sx={{ display: { xs: 'none', md: 'none', lg: 'none' } }}>
                    <Grid item xs={12}>
                      <Typography variant="h6" align="center">
                        Total Amount:
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        id="TotalAmt"
                        name="TotalAmt"
                        label="TotalAmt"
                        variant="filled"
                        fullWidth
                        className="custom-textfield"
                        {...register('TotalAmt')}
                        value={watch('TotalAmt') || 0.00}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* </Paper> */}
              </Grid>
            </Grid>
            <Grid container spacing={1} sx={{ marginTop: "1px", display: 'flex', justifyContent: 'flex-end' }}>
              <Grid item xs={12} sm={10} >
                <Grid container spacing={0} justifyContent='flex-end'>

                  <Grid item xs={12} md={7} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Tooltip title='Click to checkout process' arrow>
                      <span>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{
                            backgroundColor: "#635bff",
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            marginX: 0.2
                          }}
                          onClick={handleCheckoutClick}
                          // disabled={BookId === -1 || !isBookingConfirmed}
                          disabled={BookId === -1 || !isBookingConfirmed || !payAdvice.every(item => item.PaymentSt === "Paid") || isCheckoutProcessing}
                        >
                          {isCheckoutProcessing ? <CircularProgress size={24} /> : "Checkout"}
                        </Button>
                      </span>
                    </Tooltip>

                    <Tooltip title='Print document' arrow>
                      <span>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ backgroundColor: '#635BFF', marginX: 0.2 }}
                          onClick={handlePrint}
                          disabled={BookId == -1 ? true : false}
                        >
                          Print
                        </Button>
                      </span>
                    </Tooltip>

                    <Tooltip title='Back to previous' arrow>
                      <span>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ backgroundColor: '#635BFF', marginX: 0.2 }}
                          onClick={handleClickCancel}
                        >
                          Exit
                        </Button>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
          <div style={{ display: 'none' }}>
            {<BReport contentRef={contentRef} DataObj={watch()} />}
          </div>
          <ConfirmationDialog
            open={openCheckoutConfirm}
            onClose={() => setOpenCheckoutConfirm(false)}
            onConfirm={handleCheckoutConfirm}
            title="Confirm Checkout"
            message="Are you sure you want to checkout this booking?"
          />
          <ConfirmationDialog
            open={openCheckinConfirm}
            onClose={() => setOpenCheckinConfirm(false)}
            onConfirm={handleCheckinConfirm}
            title="Cancel Check-out"
            message="Are you sure you want to check-in this booking?"
          />
          {showPayAdvice && payAdvice.length > 0 && (
            <Grid container sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    mb: 1,
                    fontSize: { xs: '0.85rem', sm: '0.95rem' },
                    fontWeight: 'bold',
                    color: '#1976d2',
                    background: 'lightgray',
                    padding: { xs: '6px 8px', sm: '8px 12px' },
                    borderRadius: '4px',
                    borderLeft: '4px solid #1976d2'
                  }}
                >
                  💰 Payment Advice Details
                </Typography>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 200,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    background: 'linear(145deg, #ffffff, #fafafa)',
                    overflowX: 'auto'
                  }}
                >
                  <Table
                    stickyHeader
                    size="small"
                    sx={{
                      minWidth: 650,
                      '& .MuiTableCell-root': {
                        padding: { xs: '2px 4px', sm: '4px 6px' },
                        border: '1px solid #e0e0e0',
                        lineHeight: '1.2'
                      },
                      '& .MuiTableHead-root .MuiTableCell-root': {
                        background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        padding: { xs: '4px 6px', sm: '6px 8px' },
                        borderBottom: '2px solid #5a6fd8',
                        whiteSpace: 'nowrap'
                      },
                      '& .MuiTableBody-root .MuiTableCell-root': {
                        fontSize: { xs: '0.7rem', sm: '0.75rem' },
                        padding: { xs: '2px 4px', sm: '4px 6px' },
                        whiteSpace: 'nowrap'
                      },
                      '& .MuiTableRow-root': {
                        height: { xs: '28px', sm: '32px' },
                        cursor: 'pointer'
                      }
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{
                          width: { xs: '12%', sm: '10%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>AdvNo</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>AdvDt</TableCell>
                        <TableCell sx={{
                          width: { xs: '12%', sm: '10%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>AdviceFor</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="right">AdvAmt</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="right">RcdAmt</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="right">Balance</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="center">DueDays</TableCell>
                        <TableCell sx={{
                          width: { xs: '10%', sm: '8%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>RecDt</TableCell>
                        <TableCell sx={{
                          width: { xs: '14%', sm: '12%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }}>Remark</TableCell>
                        <TableCell sx={{
                          width: { xs: '22%', sm: '20%' },
                          background: '#d7dbd1ff !important',
                          color: 'black !important'
                        }} align="center">Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payAdvice?.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            height: { xs: '25px', sm: '28px' },
                            '&:nth-of-type(odd)': {
                              backgroundColor: '#f8fbff'
                            },
                            '&:nth-of-type(even)': {
                              backgroundColor: '#ffffff'
                            },
                            '&:hover': {
                              backgroundColor: '#f0f7ff'
                            }
                          }}
                          onDoubleClick={() => {
                            const url = `/advicegeneratetable?PytAdvId=${item.PytAdvId}`;
                            window.open(url, '_blank');
                          }}
                        >
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: '#1565c0',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {item?.PytAdvNo}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            color: '#666',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {moment(item?.PytAdvDt).format("DD-MM-YYYY")}
                          </TableCell>
                          <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }}>
                            <Chip
                              label={
                                item?.PytAdvFor === "D" ? "Deposit" :
                                  item?.PytAdvFor === "R" ? "Rent" :
                                    item?.PytAdvFor === "O" ? "Other" :
                                      item?.PytAdvFor === "T" ? "TopUp" : ""
                              }
                              size="small"
                              sx={{
                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                height: { xs: '16px', sm: '18px' },
                                fontWeight: 'bold',
                                backgroundColor:
                                  item?.PytAdvFor === "D" ? '#e8f5e9' :
                                    item?.PytAdvFor === "R" ? '#fff3e0' :
                                      item?.PytAdvFor === "O" ? '#f3e5f5' :
                                        '#e1f5fe',
                                color:
                                  item?.PytAdvFor === "D" ? '#2e7d32' :
                                    item?.PytAdvFor === "R" ? '#ef6c00' :
                                      item?.PytAdvFor === "O" ? '#7b1fa2' :
                                        '#0277bd'
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: '#2e7d32',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }} align="right">
                            ₹{item?.Amount}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: '#1976d2',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }} align="right">
                            ₹{item?.RcdAmt || '0'}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            fontWeight: 'bold',
                            color: item?.BalAmount > 0 ? '#d32f2f' : '#2e7d32',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }} align="right">
                            ₹{item?.BalAmount}
                          </TableCell>
                          <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                            <Chip
                              label={item?.DueDays}
                              size="small"
                              sx={{
                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                height: { xs: '16px', sm: '18px' },
                                fontWeight: 'bold',
                                color: 'white',
                                backgroundColor:
                                  item?.DueDays === 0 ? '#4caf50' :
                                    item?.DueDays <= 7 ? '#ff9800' :
                                      item?.DueDays <= 30 ? '#f44336' :
                                        '#d32f2f'
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            color: '#666',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {item?.RecDt ? moment(item.RecDt).format("DD-MM-YYYY") : "-"}
                          </TableCell>
                          <TableCell sx={{
                            padding: { xs: '2px 4px', sm: '4px 6px' },
                            color: '#666',
                            fontSize: { xs: '0.7rem', sm: '0.75rem' }
                          }}>
                            {item?.Remark || "-"}
                          </TableCell>
                          <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                            {item?.PaymentSt && (
                              <Chip
                                label={item.PaymentSt}
                                size="small"
                                sx={{
                                  fontWeight: 'bold',
                                  color: 'white',
                                  backgroundColor:
                                    item.PaymentSt.toLowerCase() === 'paid' ? '#4CAF50' :
                                      item.PaymentSt.toLowerCase() === 'partial' ? '#FF9800' :
                                        '#F44336',
                                  marginRight: item.PaymentSt.toLowerCase() !== 'paid' ? '4px' : 0,
                                  fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                  height: { xs: '18px', sm: '20px' },
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                                }}
                              />
                            )}
                            {item?.PaymentSt?.toLowerCase() !== 'paid' && (
                              <Box sx={{
                                display: 'inline-flex',
                                gap: 0.5,
                                ml: 0.5,
                                flexWrap: { xs: 'wrap', sm: 'nowrap' }
                              }}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  onClick={() => handleSendPaymentLink(item)}
                                  sx={{
                                    padding: { xs: '1px 6px', sm: '2px 8px' },
                                    minWidth: 'auto',
                                    fontSize: { xs: '0.55rem', sm: '0.6rem' },
                                    height: { xs: '20px', sm: '22px' },
                                    background: 'linear(45deg, #2196F3, #21CBF3)',
                                    boxShadow: '0 1px 3px rgba(33, 150, 243, 0.3)',
                                    '&:hover': {
                                      background: 'linear(45deg, #1976D2, #00B0FF)',
                                      boxShadow: '0 2px 5px rgba(33, 150, 243, 0.4)'
                                    }
                                  }}
                                >
                                  {loadingPaymentLinks[item.PytAdvId] ? (
                                    <CircularProgress size={10} sx={{ color: 'white' }} />
                                  ) : (
                                    '💳 Pay'
                                  )}
                                </Button>

                                <Tooltip title="Refresh Data" arrow>
                                  <IconButton
                                    size="small"
                                    onClick={() => fetchPayAdvice(BookId)}
                                    sx={{
                                      padding: '2px',
                                      '&:hover': {
                                        backgroundColor: 'rgba(255, 152, 0, 0.1)',
                                        transform: 'rotate(90deg)',
                                        transition: 'transform 0.3s ease'
                                      },
                                      height: { xs: '20px', sm: '22px' },
                                      width: { xs: '20px', sm: '22px' }
                                    }}
                                  >
                                    <RefreshIcon sx={{
                                      fontSize: { xs: '12px', sm: '14px' },
                                      color: '#FF9800',
                                      fontWeight: 'bold'
                                    }} />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Box >
    </>
  )
}

export default Checkout;